import { render, staticRenderFns } from "./Aste.vue?vue&type=template&id=f1c28fd2&scoped=true&"
import script from "./Aste.vue?vue&type=script&lang=js&"
export * from "./Aste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c28fd2",
  null
  
)

export default component.exports